<template>
    <div class="suppliers-table">
        <div class="suppliers-table__header">
            <el-input
                v-model="search"
                prefix-icon="el-icon-search"
                placeholder="Type to search"
                class="search-bar"
                @keyup.native="$emit('change:search-suppliers', search)"
            />
            <el-button type="primary" @click="$emit('click:create-supplier')"
                >Create Supplier
            </el-button>
        </div>
        <el-table
            v-loading="isLoading"
            :data="suppliersData"
            style="width: 100%"
            class="base-table"
        >
            <el-table-column prop="name" sortable label="Supplier Name">
                <template slot-scope="{ row }">
                    <highlight-search :word="row.name" :search="search" />
                </template>
            </el-table-column>
            <el-table-column prop="totalProducts" label="# of Products" />
            <el-table-column prop="firstName" label="Contact Name" />
            <el-table-column prop="email" label="Contact Email" />
            <el-table-column prop="phone" label="Contact Number" width="200" />
            <el-table-column width="200">
                <el-row slot-scope="props" type="flex" justify="end">
                    <el-button @click="$emit('click:edit-supplier', props.row)"
                        >Edit</el-button
                    >
                    <!--                    <el-button type="danger">Delete</el-button>-->
                </el-row>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
import HighlightSearch from "Components/HighlightSearch";
import BaseTable from "Components/BaseTable";

export default {
    components: {
        HighlightSearch,
        BaseTable,
    },
    props: {
        suppliersData: Array,
        isLoading: Boolean,
    },
    data: () => ({
        search: "",
    }),
};
</script>

<style lang="scss" scoped>
.suppliers-table__header {
    display: flex;
    align-items: center;
    margin-bottom: 15px;

    .search-bar {
        margin-right: 10px;
    }
}
</style>
